export default __webpack_public_path__ + "static/media/04.77609cdc.jpg";